module.exports = __webpack_public_path__ + "static/media/diamond.04742265.svg";